// https://www.sitepoint.com/build-javascript-countdown-timer-no-dependencies/

window.webinarCountdowns = [];

let webinarCountdowns = document.querySelectorAll('.ash-block.webinar-countdown');
for (let index = 0; index < webinarCountdowns.length; index++) {
    const element = webinarCountdowns[index];
    getTimeRemaining(element.getAttribute("data-webinar-id"), element.getAttribute("data-endtime"));
    window.webinarCountdowns['webinarCountdown' + element.getAttribute("data-webinar-id")] = setInterval(function () {
        getTimeRemaining(element.getAttribute("data-webinar-id"), element.getAttribute("data-endtime"));
    }, 1000);
}

function getTimeRemaining(webinarId, endTime) {
    const total = Date.parse(endTime) - Date.parse(new Date());
    const seconds = Math.floor( (total/1000) % 60 );
    const minutes = Math.floor( (total/1000/60) % 60 );
    const hours = Math.floor( (total/(1000*60*60)) % 24 );
    const days = Math.floor(total / (1000 * 60 * 60 * 24));

    const el = document.querySelector(".ash-block.webinar-countdown[data-webinar-id='" + webinarId + "']")
    el.querySelector(":scope .days span:first-child").innerHTML = ('0' + days).slice(-2);
    el.querySelector(":scope .hrs span:first-child").innerHTML = ('0' + hours).slice(-2);
    el.querySelector(":scope .mins span:first-child").innerHTML = ('0' + minutes).slice(-2);
    // el.querySelector(":scope .secs span:first-child").innerHTML = ('0' + seconds).slice(-2);

    if (total <= 0) {
        clearInterval(window.webinarCountdowns['webinarCountdown' + webinarId]);

        // remove from DOM
        document.querySelector(".ash-block.webinar-countdown[data-webinar-id='" + webinarId + "']").remove();

        // replace with next event?
        fetch('/ajax/webinarUpcoming', {
            method: 'GETT',
            headers: {
                'Content-Type': 'text/html'
            }
        })
        .then(response => response.text())
        .then(data => {
            document.querySelector("#main-content > article").insertAdjacentHTML('afterbegin', data);
            window.webinarCountdowns['webinarCountdown' + document.querySelector("#main-content > article .ash-block.webinar-countdown").getAttribute("data-webinar-id")] = setInterval(function () {
                getTimeRemaining(document.querySelector("#main-content > article .ash-block.webinar-countdown").getAttribute("data-webinar-id"), document.querySelector("#main-content > article .ash-block.webinar-countdown").getAttribute("data-endtime"));
            }, 1000);
        })
    }
}